import './background-image.css';
export default {
  "backgroundImage": "pf-c-background-image",
  "backgroundImageFilter": "pf-c-background-image__filter"
};